import { environment } from 'src/environments/environment';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, LoadingController, ToastController } from '@ionic/angular';
import { Observable, EMPTY } from 'rxjs';
import { AuthConstants } from '../config/auth-constants';
import { HttpService } from '../services/http.service';
import { StorageService } from '../services/storage.service';
import { catchError, retryWhen, delay, tap, map, finalize } from 'rxjs/operators';
import { ToastService } from '../services/toast.service';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorProvider implements HttpInterceptor {

    token: string = null;

    constructor(
        private loadingCtrl: LoadingController,
        private alertCtrl: AlertController,
        private toastService: ToastService,
        private authService: AuthService,
        private storageService: StorageService,
        private router: Router) {
            this.authService.userData$.subscribe((res: any) => {
                if (res) {
                    this.token = res.token;
                }
            });
        }

    // Intercepts all HTTP requests!
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // this.loadingCtrl.getTop().then(hasLoading => {
        //     if (!hasLoading) {
        //         this.loadingCtrl.create( {
        //             spinner: 'circular',
        //             translucent: true
        //         }).then(loading => loading.present());
        //     }
        // });
        let mustBePreserved = false;
        const exclusions: string[] = environment.interceptorExcludedUrls;

        for (const toBeExluded of exclusions) {
            if (request.url.startsWith(toBeExluded)) {
                mustBePreserved = true;
                break;
            }
        }
        if (!mustBePreserved && this.token !== null) {
            const clonedReq = this.addToken(request, this.token);
            return next.handle(clonedReq).pipe(
                catchError((err, caught) => {
                    if (err instanceof HttpErrorResponse) {
                        switch ((err as HttpErrorResponse).status) {
                            case 401:
                                this.handle401Error(request, next);
                                break;
                            default:
                                throw err;
                        }
                    }
                    throw err;
                    // else {
                    //     return throwError(err);
                    // }
                }),
                retryWhen(err => {
                    let retries = 1;
                    return err.pipe(
                        delay(1000),
                        tap(() => {
                        this.showRetryToast(retries);
                        }),
                        map(error => {
                            if (retries++ === 3) {
                                throw error;
                            }
                            return error;
                        })
                    );
                }),
                catchError(err => {
                    this.presentFailedAlert('Impossibile comunicare con il sistema. Riprova più tardi!');
                    return EMPTY;
                }),
                finalize(() => {
                    // this.dismissAllLoaders();
                    // this.loadingCtrl.getTop().then(hasLoading => {
                    //     if (hasLoading) {
                    //         this.loadingCtrl.dismiss();
                    //     }
                    // })
                }));
        }
        else {
            return next.handle(request);
        }

    }

    async dismissAllLoaders() {
        let topLoader = await this.loadingCtrl.getTop();
        while (topLoader) {
          if (!(await topLoader.dismiss())) {
            throw new Error('Could not dismiss the topmost loader. Aborting...');
          }
          topLoader = await this.loadingCtrl.getTop();
        }
      }

    // Adds the token to your headers if it exists
    private addToken(request: HttpRequest<any>, token: any) {
        if (token) {
            let clone: HttpRequest<any>;
            clone = request.clone({
                setHeaders: {
                    Accept: `application/json`,
                    'Content-Type': `application/json`,
                    Authorization: `Bearer ${token}`
                }
            });
            return clone;
        }
        return request;
    }

    private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
        console.log('shoud refresh token');
        this.storageService.removeItem(AuthConstants.AUTH);
        this.router.navigate(['login']);
    }

    async presentFailedAlert(msg) {
        const alert = await this.alertCtrl.create({
            header: 'Oops',
            message: msg,
            buttons: ['OK']
        });
        alert.present();
    }

    async showRetryToast(retryCount: number) {
        this.toastService.presentToast(
            `Ooops, problemi di connesione in vista. Riprovo! (${retryCount}/3)`,
            2000);
    }
}
